// Sized on the card's own width: the 308px sidebar appears at the same viewport
// breakpoint the card used to switch at, and it is collapsible, so viewport
// width cannot predict the space available.
export const HEADER_CARD_CONTAINER = 'member-header';

// 950, not the design's 1000: the dashboard is capped at 95vw (index.scss), so
// 1000px of card needs a ~1469px viewport and 1440px laptops would stack.
export const HEADER_CARD_WIDE = `@container ${HEADER_CARD_CONTAINER} (min-width: 950px)`;

// Keeps both status chips on one line. Measured, not from the design, whose
// sample label is shorter than a real "No check-in for N days".
export const CHIPS_MIN_WIDTH = 460;

// Container queries make the card a stacking context, so it has to rise as a
// whole for a tutorial highlight inside it to clear the overlay.
export const HEADER_CARD_TUTORIAL_IDS = ['since-checkin-counter'];
